import { SiteTypeStoreModelEnum, VehicleOperationalStatusStoreModelEnum } from '@domain/single-site/single-site.enums';

import { DepotOverviewChartViewModel } from '@shared/components/depot-overview-chart';
import { VEHICLE_STATUS_PROPERTIES_MAP } from '@shared/components/vehicle-operational-status-icon';

import { DepotVehicleOverviewCardViewModel } from './depot-overview-card.view-model';

// Builds the fleet (vehicle) variant of the depot overview card view model from a vehicle status -> count map.
// Shared by the single-site overview (per-site status) and the multi-site dashboard (aggregated fleet status).
export const createDepotVehicleOverviewCardViewModel = (
  statusData: Partial<Record<VehicleOperationalStatusStoreModelEnum, number>>
): DepotVehicleOverviewCardViewModel => {
  const chartVm: DepotOverviewChartViewModel<VehicleOperationalStatusStoreModelEnum> = {
    data: {
      [VehicleOperationalStatusStoreModelEnum.Ready]: statusData[VehicleOperationalStatusStoreModelEnum.Ready] || 0,
      [VehicleOperationalStatusStoreModelEnum.Charging]: statusData[VehicleOperationalStatusStoreModelEnum.Charging] || 0,
      [VehicleOperationalStatusStoreModelEnum.Queued]: statusData[VehicleOperationalStatusStoreModelEnum.Queued] || 0,
      [VehicleOperationalStatusStoreModelEnum.Faulted]: statusData[VehicleOperationalStatusStoreModelEnum.Faulted] || 0,
      [VehicleOperationalStatusStoreModelEnum.InDepot]: statusData[VehicleOperationalStatusStoreModelEnum.InDepot] || 0,
      [VehicleOperationalStatusStoreModelEnum.OnTheRoad]: statusData[VehicleOperationalStatusStoreModelEnum.OnTheRoad] || 0,
    },
    propertiesMap: VEHICLE_STATUS_PROPERTIES_MAP,
  };

  if (statusData[VehicleOperationalStatusStoreModelEnum.Unknown]) {
    chartVm.data[VehicleOperationalStatusStoreModelEnum.Unknown] = statusData[VehicleOperationalStatusStoreModelEnum.Unknown];
  }

  return {
    chartVm,
    type: SiteTypeStoreModelEnum.Fleet,
  };
};
